export default __webpack_public_path__ + "static/banner-bg-metaverse-94da9a89c912dcd04036502af56431d4.png";